<template>
  <div id="footer-section" class="noto-sans-sc-font-family">
    <div id="footer-main-container" class="py-6 px-4">

      <div
        class="footer-subjects-container"
        v-for="(subject, index) in footerSubjects"
        :key="index"
      >
        <div class="footer-subject-title text-uppercase my-2">{{ subject.title }}</div>
        <div class="footer-subject-item-container d-flex flex-wrap justify-start">

          <div
            class="footer-subject-item mt-2 mb-3"
            v-for="(item, index) in subject.items"
            :key="index"
          >
            <router-link
              v-if="item.page && !item.page.isExternalLink"
              :to="item.page.url"
            >{{item.title}}</router-link>

            
            <!-- <a
              v-else-if="item.page && item.page.isExternalLink"
              :href="item.page.url"
              target="_blank"
            >{{item.title}}</a> -->


             <!-- <a
              v-if="item.page && item.page.isExternalLink"
              :href="item.page.url"
              target="_blank"
            >{{item.title}}</a> -->
            <!-- <div v-else>{{item.title}}</div> -->
          </div>

        </div>
        <v-divider dark></v-divider>
      </div>
      <div id="footer-social-media-section" class="d-flex mt-8 mb-2">
        <div id="footer-social-media-text">FOLLOW US</div>
        <a v-for="(socialMedia, index) in socialMedias" :key="index" :href="socialMedia.url">
          <div class="social-media icon-sprite" :class="socialMedia.cssClass"></div>
        </a>
      </div>

    </div>
    <div
      id="footer-copyright-statement"
      class="text-center verdana-font-family py-3"
    >{{ copyRightStatement }}</div>
  </div>
</template>

<script>
// import footerMixins from "../../mixins/footerMixins";
export default {
  // mixins: [footerMixins],
  data: () => ({
    footerSubjects: [
      {
        title: "Support",
        items: [
          {
            title: "FAQ",
            page: {
              url: "/support/faq",
             
            }
          },
          {
            title: "Review",
            page: {
             url: "/support/refund_exchange",
             
            }
          },
          {
            title: "Warranty",
            page: {
              url: "/support/warranty",
            
            
            }
          },
          {
            title: "Contact Us",
            page: {
              url: "/support/contact_us",
             
            }
          }
        ]
      },
      {
        title: "Explore",
        items: [
          {
            title: "Buy on Amazon",
            page: {
              url: "https://www.amazon.com/1byone",
              isLink: true
            }
          },
          {
            title: "Look for products",
            page: {
              url: "/search?c=health"
            }
          }
        ]
      },
      {
        title: "Privacy",
        items: [
          {
            title: "Terms of Use",
            page: {
              url: "/support/terms_condition"
            }
          },
          {
            title: "Privacy Policy",
            page: {
              url: "/support/privacy_policy"
            }
          }
        ]
      }
    ],
socialMedias: [
      {
        type: "Facebook",
        image: "facebook.png",
        url: "//facebook.com/1byonehealth/",
        cssClass: "social-media-facebook"
      },
      {
        type: "Instagram",
        image: "instagram.png",
        url: "//instagram.com/1byone_official/",
        cssClass: "social-media-instagram"
      },
      {
        type: "YouTube",
        image: "youtube.png",
        url: "//youtube.com/user/1BYONEDOORBELLS",
        cssClass: "social-media-youtube"
      },
      {
        type: "twitter",
        image: "twitter.png",
        url: "//twitter.com/The_1ByOne",
        cssClass: "social-media-twitter"
      }
    ]

  }),

   computed: {
    copyRightStatement() {
      let currentYear = new Date().getFullYear();
      return `Copyright © ${currentYear} 1byone, Inc. All rights reserved`;
    }
  }
   
};
</script>

<style scoped>
#footer-main-container {
  background-color: #333333;
  color: white;
}

.footer-subject-title {
  font-size: 17px;
}

.footer-subject-item a {
  color: white;
  font-size: 14px;
}

.footer-subject-item:not(:nth-child(1)) {
  margin-left: 13px;
}

.social-media {
  background-size: 350px;
  height: 25px;
  width: 25px;
  background-color: white;
  border-radius: 50%;
  margin-left: 17px;
}

.social-media-twitter {
  background-position: -289px 1px;
}

.social-media-instagram {
  background-position: -246px 0px;
}

.social-media-youtube {
  background-position: -205px 0px;
}

.social-media-facebook {
  background-position: -163px -2px;
}

#footer-copyright-statement {
  background-color: #212121;
  color: white;
  font-size: 11px;
}
</style>
